import { zeroPad } from 'utils/utils';
import { FONT_TITLE, TIMER_TEXT_COLOUR, TIMER_SHADOW_COLOUR } from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';

class HudTimer extends Phaser.Group {
  constructor({ game }) {
    super(game);
    this.bg = this.game.make.image(0, 0, 'ui', 'timerbg');
    /**
     * Create textfields
     */
    this.minutesDisplay = createTextField(this.game, FONT_TITLE, 42, TIMER_TEXT_COLOUR, 78, -12);
    this.minutesDisplay.stroke = TIMER_SHADOW_COLOUR;
    this.minutesDisplay.strokeThickness = 9;
    this.minutesDisplay.setShadow(3, 3, TIMER_SHADOW_COLOUR, 0);
    const y = this.minutesDisplay.y + 9;
    this.secondsDisplay = createTextField(this.game, FONT_TITLE, 32, TIMER_TEXT_COLOUR, 170, y);
    this.secondsDisplay.stroke = TIMER_SHADOW_COLOUR;
    this.secondsDisplay.strokeThickness = 9;
    this.secondsDisplay.setShadow(3, 3, TIMER_SHADOW_COLOUR, 0);

    this.add(this.bg);
    this.add(this.minutesDisplay);
    this.add(this.secondsDisplay);

    this.reset();
  }

  reset() {
    this.setTime(0);
  }

  setTime(value) {
    const seconds = Math.floor(value / 1000) % 60;
    const minutes = Math.floor(value / 60000) % 60;
    this.render(minutes, seconds);
  }

  render(minutes, seconds) {
    this.minutesDisplay.text = zeroPad(minutes, 2);
    this.secondsDisplay.text = zeroPad(seconds, 2);
  }

  destroy(destroyChildren = true, soft) {
    this.minutesDisplay = null;
    this.secondsDisplay = null;

    super.destroy(destroyChildren);
  }
}
export default HudTimer;
